var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.reload)?_c('TransactionTemplate',{ref:"delivery-note",attrs:{"screenJson":_vm.getScreenJson,"setLoading":_vm.setLoading,"localDataGrid":false,"backButtonRoute":_vm.backButtonRoute,"data-model":_vm.dataModel,"isLoaded":_vm.loaded,"validationSummary":_vm.validationSummary,"almondcoDespatchData":_vm.almondcoDespatchData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }